<template>
  <div id="particles-js" class="Login_container">
    <div class="login_area" @keyup.enter="handleSubmit('formItem')">
      <h1 class="title">全能i家运营平台</h1>
      <Form ref="formItem" :model="formItem" :rules="ruleInline">
        <FormItem prop="userName">
          <Input v-model="formItem.userName" placeholder="用户名" size="large">
            <Icon
              type="ios-person-outline"
              slot="prepend"
              color="rgb(24, 144, 255)"
              size="22"
            />
          </Input>
        </FormItem>
        <FormItem prop="pwd">
          <Input
            type="password"
            password
            v-model="formItem.password"
            placeholder="密码"
            size="large"
            @keyup.enter="handleSubmit('formItem')"
          >
            <Icon
              type="ios-lock-outline"
              slot="prepend"
              color="rgb(24, 144, 255)"
              size="22"
            />
          </Input>
        </FormItem>
        <FormItem>
          <div class="forget">
            <Checkbox v-model="auto" on-change="autoLogin">自动登录</Checkbox>
            <span class="flot_right" @click="forgetpwd">忘记密码</span>
          </div>
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
            style="width: 100%"
            size="large"
            >登录</Button
          >
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import "particles.js/particles";
import md5 from "md5";
import qs from "qs";
const particlesJS = window.particlesJS;
export default {
  data() {
    return {
      auto: false,
      formItem: {
        userName: "",
        password: "",
      },
      ruleInline: {
        userName: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.initCartoon();
    if (localStorage.getItem("auto")) {
      this.formItem;
    }
  },
  methods: {
    forgetpwd() {
      this.$Notice.success({
        title: "请联系聚赚管理员重置密码",
        duration: 0,
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.login();
        }
      });
    },
    async login() {
      var list = Object.assign({}, this.formItem);
      let data = await this.$post("/system/webLogin", list);
      window.userInfo = data || {};
      window.userInfo.type = this.formItem.userName == "admin" ? 1 : data.type;
      localStorage.setItem("userInfo", JSON.stringify(data));
      let startTime = new Date().getTime(); //设置登录时间
      localStorage.setItem("startTime", startTime);
      if (data.companyId) {
        // 商户专用运营账号（服务商）
        this.$router.push({ path: "/orderlist" });
      } else {
        this.$router.push({ path: "/productlist" });
      }
    },
    initCartoon() {
      try {
        particlesJS.load("particles-js", "/static/particles.json", function () {
          console.log("callback - particles-js config loaded");
        });
      } catch (error) {
        console.log(error);
      }
    },
    autoLogin() {},
  },
};
</script>
<style lang="less" scoped>
.Login_container {
  position: relative;
  height: 100%;
  background: #f7fafc;
  overflow: hidden;
}
.login_area {
  position: absolute;
  top: 40%;
  left: 50%;
  height: 400px;
  width: 368px;
  transform: translate(-50%, -50%);
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 33px;
    text-align: center;
    margin-bottom: 50px;
  }
  .forget {
    margin-bottom: 20px;
    text-align: left;
    font-size: 14px;
    color: #1890ff;
    cursor: pointer;
    .flot_right {
      float: right;
    }
  }
}
</style>
